// src/scripts/email.js
import emailjs from '@emailjs/browser';

// ---- CONFIG ----
// For Create React App / generic webpack:
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SERVICE_ID_QUOTE = process.env.REACT_APP_EMAILJS_SERVICE_ID_QUOTE;
const TEMPLATE_ID_QUOTE = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_QUOTE;

// If you haven't wired env vars yet, you can temporarily hardcode:
// const PUBLIC_KEY = 'YOUR_PUBLIC_KEY';
// const SERVICE_ID_QUOTE = 'YOUR_SERVICE_ID';
// const TEMPLATE_ID_QUOTE = 'YOUR_TEMPLATE_ID';

let initialized = false;

function ensureInitialized() {
    if (initialized) return;
    if (!PUBLIC_KEY) {
        console.error(
            'EmailJS public key missing. Ensure REACT_APP_EMAILJS_PUBLIC_KEY is set in your .env file.'
        );
        return;
    }
    emailjs.init({ publicKey: PUBLIC_KEY });
    initialized = true;
}

/**
 * Send a quote email using EmailJS.
 * `values` should contain the form fields.
 * `options.source` is a label like "Quote Page" or "Home Quote Teaser".
 */
export async function sendQuoteEmail(values, options = {}) {
    ensureInitialized();

    if (!SERVICE_ID_QUOTE || !TEMPLATE_ID_QUOTE) {
        throw new Error(
            'EmailJS quote service/template IDs are missing. Check your .env (REACT_APP_EMAILJS_*).'
        );
    }

    const {
        name,
        email,
        phone,
        serviceType,
        city,
        propertyType,
        size,
        frequency,
        preferredDate,
        message,
        referral,
    } = values;

    const source = options.source || 'Quote Form';

    // Map to your EmailJS template variables ({{...}})
    const templateParams = {
        // Contact info
        name,
        email,
        phone,

        // Service details
        service_type: serviceType,
        city,
        property_type: propertyType || '',
        size: size || '',
        frequency: frequency || '',
        preferred_date: preferredDate || '',

        // Extras
        message: message || '',
        referral: referral || '',

        // Meta
        source,
        time: new Date().toLocaleString(),
    };

    // Extra sanity check for required fields
    if (!name || !email || !phone || !serviceType || !city) {
        throw new Error('Missing required quote fields.');
    }

    return emailjs.send(SERVICE_ID_QUOTE, TEMPLATE_ID_QUOTE, templateParams);
}
